var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Tabs',[_c('Tab',{attrs:{"title":"Investigation"}},[_c('InvestigationRegister')],1),_c('Tab',{attrs:{"title":"Non Conformance"}},[_c('NonConformance')],1),_c('Tab',{attrs:{"title":"Performance Management"}},[_c('Performance')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }